import * as angular from "angular";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";

let PushedOverLimitComponent = {
    selector: "vcPushedOverLimit",
    templateUrl: "/angular/components/limit/pushed-over-limit.component.html",
    bindings: {
        limit: "=",
        licenseType: "=",
    },
    controller: class PushedOverLimitController {
        // * bindings for typescript compiler *
        public limit: any;
        public licenseType: any;
        // ************************************

        private $scope: any;
        private dialog: DialogUtils;

        public isLeaderView: boolean;
        public activeCampaign: Campaign;
        public userDataProvider: UserDataProvider;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            UserDataProvider: UserDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.userDataProvider = UserDataProvider;
        }

        dismiss(): void {
            this.dialog.hide();
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            this.dialog
                .show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                        reloadOnSuccess: false,
                    },
                    fullscreen: true,
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                })
                .then(() => {
                    this.dialog.hide();
                });
        }

        openChooseQuantityDialog(): void {
            this.dialog
                .show({
                    component: "vc-seats-settings-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {},
                })
                .then((numSeats: any) => {
                    this.openPurchaseSeatsDialog(numSeats);
                });
        }

        openPurchaseSeatsDialog(numSeats: any): void {
            this.dialog
                .show({
                    component: "purchase-seats-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        numSeats: numSeats,
                    },
                })
                .then(() => {
                    this.userDataProvider.resetUsersCount();
                    this.dialog.hide();
                });
        }
    },
};

angular
    .module("limit")
    .component(PushedOverLimitComponent.selector, PushedOverLimitComponent);
